import Constants from "../../../../../constants/Common";
import { MATRIX_SERVICE } from "./../../../../../api/Matrix";
import { matrixKeys } from "../queries";
import { message } from "antd";
import { queryClient } from "../../../../..";
import { useMutation } from "@tanstack/react-query";
export const useUpdatePermissions = () => {
  return useMutation(MATRIX_SERVICE.updatePermission, {
    onSuccess: () => {
      message.success(Constants.statusMessage.updated);
      queryClient.invalidateQueries([matrixKeys.getMatrix]);
    },
  });
};
